import { Link } from 'react-router-dom';
import { articles } from '@/mocks/varietyData';

export default function LatestArticlesSection() {
  return (
    <section className="py-10 md:py-16 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-900 mb-2">
            最新资讯
          </h2>
          <p className="text-sm text-foreground-600">
            综艺圈最新动态，一手掌握
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 transition-all hover:scale-[1.02] cursor-pointer"
            >
              <div className="relative w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-xs text-foreground-400">{article.publishDate}</span>
                  <span className="text-xs text-foreground-400">·</span>
                  <span className="text-xs text-foreground-400">{article.readCount.toLocaleString()} 阅读</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors leading-relaxed">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-3 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2 flex-wrap">
                  {article.tags.map((tag) => (
                    <span
                      key={tag}
                      className="text-xs bg-background-100 text-foreground-500 px-2 py-0.5 rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}